import React, { useState } from 'react';
import './ContactPage.css';

// Import the Google Maps components
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  // Google Maps configuration
  const mapContainerStyle = {
    width: '100%',
    height: '400px'
  };

  // Coordinates for Hohoe, Ghana
  const center = {
    lat: 7.1518, // Hohoe latitude
    lng: 0.4736  // Hohoe longitude
  };

  // Map options
  const mapOptions = {
    zoom: 15,
    mapTypeControl: true,
    streetViewControl: true,
    fullscreenControl: true
  };

  // Marker position (same as center or adjust as needed)
  const markerPosition = {
    lat: 7.1518,
    lng: 0.4736
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contactpage">
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
      </div>

      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="info-card">
              <h3>📍 Location</h3>
              <p>Hohoe, Ghana<br />Volta Region</p>
            </div>
            <div className="info-card">
              <h3>📞 Phone</h3>
             <p>📞 (+233) 24-109-8890</p>
          <p>📞 (+233) 24-144-4544</p>
            </div>
            <div className="info-card">
              <h3>✉️ Email</h3>
              <p>✉️ goldennesthtl@gmail.com<br />✉️ goldennesthtl@gmail.com</p>
            </div>
            <div className="info-card">
              <h3>🕒 Hours</h3>
              <p>Front Desk: 24/7<br />Restaurant: 6AM - 11PM<br />Spa: 8AM - 10PM</p>
            </div>
          </div>

          <div className="contact-form">
            <h2>Send us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message *"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>
        </div>

        <div className="map-section">
          <h2>Find Us</h2>
          <div className="map-container">
            {/* Replace YOUR_GOOGLE_MAPS_API_KEY with your actual API key */}
            <LoadScript
              googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY"
            >
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={center}
                zoom={mapOptions.zoom}
                options={mapOptions}
              >
                <Marker
                  position={markerPosition}
                  title="Golden Nest Hotel"
                  label="Golden Nest Hotel"
                />
              </GoogleMap>
            </LoadScript>
            
            {/* Directions link */}
            <div className="map-actions">
              <a 
                href={`https://www.google.com/maps/dir/?api=1&destination=${center.lat},${center.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                className="directions-btn"
              >
                📍 Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;